import { render, staticRenderFns } from "./guide-someone-though-an-obstacle.vue?vue&type=template&id=5480cea0&"
import script from "./guide-someone-though-an-obstacle.vue?vue&type=script&lang=js&"
export * from "./guide-someone-though-an-obstacle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports